const EHBLResponseApiUrls = {
    GET: `${process.env.REACT_APP_USER_EHBL_URL}/ehbl/response/get`,
    GET_HOUSE_BILL_RESPONSE: `${process.env.REACT_APP_USER_EHBL_URL}/ehbl/response/getEhblResponse`,
    GET_CLOSE_MESSAGE_RESPONSE: `${process.env.REACT_APP_USER_EHBL_URL}/ehbl/response/getEhblCloseMessageResponse`,
    GET_D4_NOTICE_RESPONSE: `${process.env.REACT_APP_USER_EHBL_URL}/ehbl/response/getEhblD4Notice`
};

export default EHBLResponseApiUrls
